var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"communication-card",style:({
    backgroundImage: `linear-gradient(180deg, ${_vm.list.name == '开源社区' || _vm.list.name == '资源中心'
      ? '#0F71E2'
      : '#03A2FF'
      } 30%, rgba(255,255,255,0.34) 100%),url(${_vm.list.url})`
  })},[_c('div',{staticClass:"card-header"},[_c('img',{attrs:{"src":require("@/assets/images/website/home/jl2.png"),"alt":""}}),_vm._v(" "+_vm._s(_vm.list.name)+" ")]),_c('div',{staticClass:"card-desc"},[_vm._v(" "+_vm._s(_vm.list.desc)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }